<div class="executed-container mt-3">
  <div class="executed__data-container">
    <div class="strong font-18 mb-3">Facturatie</div>
    <ng-container *ngIf="involvedCompanies?.length > 0">
      <div
        *ngFor="let company of involvedCompanies; let amountCompanies = count"
        class="mb-3"
      >
        <client-adjustment-company-invoice-info
          [company]="company"
          [project]="project"
          [adjustment]="adjustment"
          [baseProject]="baseProject"
          [amountCompanies]="amountCompanies"
        ></client-adjustment-company-invoice-info>
      </div>
    </ng-container>
  </div>
</div>
